import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCsAttribute } from "@plansoft-configuration-renderer/framework";
import { AttributeHeadline, AttributeWrapper, } from "../AttributeComponents";
import { DefaultValueTemplate } from "../AttributeValue/DefaultValueTemplate";
import { Checkboxes } from "../Controls/Checkboxes/Checkboxes";
// import only absolutely necessary components for the fallback renderer
import { Edit } from "../Controls/Edit/Edit";
import { Select } from "../Controls/Select/Select";
import { SubstructureStub } from "../Controls/Substructure/SubstructureStub";
import { TableControl, TableControlFetchMode } from "../Controls/Table";
/**
 * This function determines which attribute is rendered base on attribute type
 * - works without layout information
 */
export function AttributeSelectorByAttributeType() {
    const attribute = useCsAttribute();
    const wrapperProps = {
        identifier: attribute.id,
        dataType: attribute.dataType,
    };
    if (attribute.tableId) {
        return (_jsxs(AttributeWrapper, Object.assign({}, wrapperProps, { children: [_jsx(AttributeHeadline, {}), _jsx(TableControl, { fetchMode: TableControlFetchMode.Client, pageSize: 25, density: "compact" })] })));
    }
    // edit field
    if (attribute.isEditable) {
        return (_jsxs(AttributeWrapper, Object.assign({}, wrapperProps, { children: [_jsx(AttributeHeadline, {}), _jsx(Edit, {})] })));
    }
    // sub configuration
    if (attribute.isConfiguration) {
        // fallback mechanism with AttributeSelectorContext
        return (_jsxs(AttributeWrapper, Object.assign({}, wrapperProps, { children: [_jsx(AttributeHeadline, {}), _jsx(SubstructureStub, {})] })));
    }
    // multi option type
    if (attribute.isMultiValued) {
        return (_jsxs(AttributeWrapper, Object.assign({}, wrapperProps, { children: [_jsx(AttributeHeadline, {}), _jsx(Checkboxes, { children: _jsx(DefaultValueTemplate, {}) })] })));
    }
    // single option type
    return (_jsxs(AttributeWrapper, Object.assign({}, wrapperProps, { children: [_jsx(AttributeHeadline, {}), _jsx(Select, { children: _jsx(DefaultValueTemplate, {}) })] })));
}
//# sourceMappingURL=AttributeSelectorByAttributeType.js.map